<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <v-img
            src="https://demos.creative-tim.com/vuetify-material-dashboard/favicon.ico"
            max-height="30"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="display-1"
            v-text="profile.title"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { system_admin_items } from "@/system_admin_items.js"
  import { account_admin_items } from "@/account_admin_items.js"
  import { operator_admin_items } from "@/operator_admin_items.js"
  import { operator_user_items } from "@/operator_user_items.js"
  import { customer_user_items } from "@/customer_user_items.js"
  import { supplier_user_items } from "@/supplier_user_items.js"
  import { operator_user_chinese_items } from "@/operator_user_chinese_items.js"
  import Proxyable from "vuetify/lib/mixins/proxyable";
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',
    mixins: [Proxyable],
    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      no_items: [],
      system_admin_items: system_admin_items,
      account_admin_items: account_admin_items,
      operator_admin_items: operator_admin_items,
      operator_user_items: operator_user_items,
      customer_user_items: customer_user_items,
      supplier_user_items: supplier_user_items,
      operator_user_chinese_items: operator_user_chinese_items
    }),

    computed: {
      ...mapState(["barColor", "barImage", "role", "user"]),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        switch (this.role) {
          case 0:
            return this.system_admin_items.map(this.mapItem);
          case 1:
            return this.account_admin_items.map(this.mapItem);
          case 2:
            return this.operator_admin_items.map(this.mapItem);
          case 3:
            return this.operator_user_items.map(this.mapItem);
          case 4:
            return this.operator_user_chinese_items.map(this.mapItem);
          case 10:
          return this.customer_user_items.map(this.mapItem);
          case 11:
            return this.supplier_user_items.map(this.mapItem);
          default:
            return this.no_items.map(this.mapItem);
        }
      },
      profile () {
        let username = ''
        if (this.user) {
          if (this.role===10 || this.role===11) {
            username = this.user.fullname
          } else {
            username = this.user.name
          }
        }
        return {
          avatar: true,
          title: username,
        }
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
